let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ejL94")).then(() => parcelRequire('7Gg3B'));